import React from "react";

const UnknownError = () => {
    return (
        <div className="error">    
            <div className="col">
                <h1 className="modal-title">Unknwon Error!</h1>
                <p className="modal-desc">
                    <br />
                    Some Error Occurred
                </p>
            </div> 
        </div>
    );
};

export default UnknownError;
